module.exports = __webpack_public_path__ + "static/media/card-white.ccab7d07.svg";